import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';

import Printer from '../PrinterDialog/index';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { hasPermission } from '../../../../utils/authenticated';
import { toJS } from '../../../../utils/helper';
import Dashboard from '../../../Dashboard/index';
import { fetchPrintersRoutine, removePrinterPromise } from '../../../../redux/routines';

import { isDialogVisibleSelector } from '../../../../redux/selectors';
import { PRINTER_DIALOG } from '../../../../redux/constants/dialogs';
import PrintersGrid from '../PrintersGrid/index';

class PrintersView extends Component {

  componentWillMount() {
    this.setState({
      editable: hasPermission(['Administrator']),
    });
  }

  render() {
    const { isDialogVisible, printers, fetchPrinters, removePrinter, showDialog } = this.props;
    return (
      <Dashboard title="Printers">
        <PrintersGrid
          data={printers}
          fetch={fetchPrinters}
          onRemove={removePrinter}
          showDialog={showDialog}
        />

        {isDialogVisible(PRINTER_DIALOG) ? <Printer/> : null}
      </Dashboard>
    );
  }
}

PrintersView.propTypes = {
  fetchPrinters: PropTypes.func.isRequired,
  printers: PropTypes.object,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    printers: toJS(state.getIn(['printers', 'printers'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchPrinters: fetchPrintersRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      removePrinter: removePrinterPromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintersView);



// WEBPACK FOOTER //
// ./src/components/Admin/Printers/PrintersView/index.js